// react
import React, { useState } from 'react'

// components
import { Dialog3 as Dialog } from '@st-operations/uikit/src/v1/index.js'
import Header from '_components/header/index.jsx'
import ListView from '_components/list-view/index.jsx'
import NewEntityDialog from '_components/new-entity-dialog/index.jsx'

// styles
import './styles.scss'

const ENTITY = 'pdp-audience-notification-rules'

const list = (values) => (values || []).join(', ')

const PdpAudienceNotificationRulesPage = () => {
  const [modalOpen, setModalOpen] = useState(false)

  const toggleModal = () => setModalOpen((open) => !open)

  const columns = [
    {
      key: 'name',
      name: 'Rule',
      link: `/${ENTITY}/:_id`,
      sortable: true,
    },
    {
      key: 'enabled',
      name: 'Enabled',
      render: (item) => (item.enabled ? 'Yes' : 'No'),
    },
    {
      key: 'organizations',
      name: 'Organizations',
      render: (item) =>
        item.organizations?.length
          ? list(item.organizations.map((organization) => organization.name || organization._id))
          : 'All organizations',
    },
    {
      key: 'emails',
      name: 'Notify',
      render: (item) => list(item.emails),
    },
    {
      format: 'date',
      key: 'updated_at',
      name: 'Updated At',
      sortable: true,
    },
  ]

  // The sidebar already hides this page from client users; this covers a
  // direct URL.
  if (!window._isShareThisUser) {
    return (
      <div className="pdp-notification-rules">
        <Header title="PDP Audience Notifications" />
        <p className="pdp-notification-rules__description">
          These settings are available to ShareThis users only.
        </p>
      </div>
    )
  }

  return (
    <div id="pdp-audience-notification-rules-page" className="pdp-notification-rules">
      <Header
        title="PDP Audience Notifications"
        actions={[{ children: 'Create New Rule', onClick: toggleModal }]}
      />

      <p className="pdp-notification-rules__description">
        Who gets emailed when a PDP audience is approved. Every enabled rule that matches the
        audience&rsquo;s organization contributes its addresses, and a rule naming no organizations
        matches all of them. An approval no rule matches sends no email at all.
      </p>

      <ListView
        columns={columns}
        entities={ENTITY}
        fields={['name', 'enabled', 'organizations', 'emails', 'updated_at']}
        filters={[]}
        searchable={true}
        sort_key={'name'}
        sort_dir={1}
      />

      <Dialog open={modalOpen} close={toggleModal}>
        <NewEntityDialog
          close={toggleModal}
          entities={ENTITY}
          open={modalOpen}
          title="Enter a name for your new notification rule"
        />
      </Dialog>
    </div>
  )
}

// export
export default PdpAudienceNotificationRulesPage
